import logoWP from "assets/images/media/logo-twp.png";
import logoNPR from "assets/images/media/logo-npr.png";
import logoWSJ from "assets/images/media/logo-wsj.png";
import logoFORTUNE from "assets/images/media/logo-fortune.png";
import logoTC from "assets/images/media/logo-tc.png";
import logoINC from "assets/images/media/logo-inc.png";
import logoXC from "assets/images/media/logo-xconomy.png";
import logoVentureBeat from "assets/images/media/logo-venturebeat.png";

const media = {
  WP: {
    title: "The Washington Post",
    img: logoWP,
    url: "https://www.washingtonpost.com/business/capitalbusiness/this-nva-start-up-wants-bring-public-notaries-into-the-mobile-economy/2016/02/03/d7ec6faa-caab-11e5-88ff-e2d1b4289c2f_story.html?utm_term=.46cfc24fbc5f",
  },
  NPR: {
    title: "NPR",
    img: logoNPR,
    url: "https://www.npr.org/sections/alltechconsidered/2017/06/12/532586426/notaries-are-starting-to-put-down-the-stamp-and-pick-up-a-webcam",
  },
  WSJ: {
    title: "Wall Street Journal",
    img: logoWSJ,
    url: "https://www.wsj.com/articles/mortgage-closings-just-took-a-big-step-into-the-digital-age-1502287181",
  },
  FORTUNE: {
    title: "Fortune",
    img: logoFORTUNE,
    url: "https://fortune.com/2016/06/13/notarize-iphone-notary-app/",
  },
  TC: {
    title: "TechCrunch",
    img: logoTC,
    url: "https://techcrunch.com/2016/02/04/now-you-can-swipe-for-an-on-demand-notary-too/",
  },
  INC: {
    title: "INC.",
    img: logoINC,
    url: "https://www.inc.com/anna-hensel/you-can-now-get-documents-notarized-remotely.html",
  },
  XCONOMY: {
    title: "XCONOMY",
    img: logoXC,
    url: "https://www.xconomy.com/boston/2016/02/04/polaris-partners-unveils-new-startup-notarize-with-2-4m-funding/",
  },
  VENTUREBEAT: {
    title: "Venture Beat",
    img: logoVentureBeat,
    url: "https://venturebeat.com/2016/02/04/funding-daily-notarize-launches-with-2-4-million-to-shake-up-the-notary-system/",
  },
};

export default media;
